<div class="invoice-container">
  <div *ngFor="let page of paginatedContent let i = index" class="a4-paper page-break">
    <!-- Page Header -->
    <header class="header fx-col fx-gap-20 ">
      <div class="fx-row-w-100 fx-space-between">
        <div class="logo">
          <img [src]="imageSrc" alt="Nter Logo"/>
        </div>
        <div>Page {{ i + 1 }} / {{ paginatedContent.length }}</div>
      </div>

      <div style="height: 20px"><h2>Transaction Summary: {{ summary.retailerCompanyName }} </h2></div>

      <div class="summary-details">
        <div class="details fx-row-w-100">
          <div class="flex-column fx-gap-10" style="text-align: justify">
            <div><strong>Start Date:</strong> {{ displayShortDate(summary.startDate) }}</div>
            <div><strong>End Date:</strong> {{ displayShortDate(summary.endDate) }}</div>
          </div>

          <div class="flex-column fx-gap-10" style="text-align: justify">
            <div><strong>Date issued:</strong> {{ dateIssued }}</div>
            <div><strong>Currency:</strong> {{ currency }}</div>
          </div>
        </div>
      </div>

    </header>

    <div *ngFor="let section of page let j = index">
    <!-- Closed Sales Table -->
      <ng-container *ngIf="section.type === 'closedSales'">
      <br/>
      <h2>Closed sales for the period</h2>
      <table>

        <thead>
        <tr>
          <th>Trading Date</th>
          <th>Total Sales</th>
          <th>Platform Payments</th>
          <th>External Payments</th>
          <th>Charges (Ex. VAT)</th>
          <th>VAT on Charges</th>
          <th>Settlement Balance</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let sale of section.data">
          <td>{{ displayShortDate(sale.tradingDate) }}</td>
          <td>{{ sale.totalSales | currency: 'R ' }}</td>
          <td>{{ sale.platformPayments | currency: 'R ' }}</td>
          <td>{{ sale.externalPayments | currency: 'R ' }}</td>
          <td>{{ sale.charges | currency: 'R ' }}</td>
          <td>{{ sale.vatOnCharges | currency: 'R ' }}</td>
          <td>{{ sale.settlementBalance | currency: 'R ' }}</td>
        </tr>
        </tbody>
        <tfoot>
        <tr *ngIf="shouldShowClosedSalesTotals(i)">
          <td>Total</td>
          <td>{{ summary.closedSalesTotals.totalSales | currency: 'R ' }}</td>
          <td>{{ summary.closedSalesTotals.platformPayments | currency: 'R ' }}</td>
          <td>{{ summary.closedSalesTotals.externalPayments | currency: 'R ' }}</td>
          <td>{{ summary.closedSalesTotals.charges | currency: 'R ' }}</td>
          <td>{{ summary.closedSalesTotals.vatOnCharges | currency: 'R ' }}</td>
          <td>{{ summary.closedSalesTotals.settlementBalance | currency: 'R ' }}</td>
        </tr>
        </tfoot>
      </table>


      <!-- Display notes only on the last page of the closed sales section -->
        <div *ngIf="shouldShowClosedSalesTotals(i)" class="notes-container">
        <div>Notes</div>
        <div><strong>External payments</strong> are payments/funds that were collected outside of the platform. E.g cash
        </div>
        <div><strong>Internal payments</strong> are payment/funds that were collected via an integrated payment method
          by the platform
        </div>
        <div><strong>Settlement balance</strong> is the net amount payable to the retailer after the charges, VAT on
          charges and external payments are deducted from the total sales amount
        </div>
      </div>
    </ng-container>

    <!-- Payout Table -->
      <ng-container *ngIf="section.type === 'payout'">
      <br/>
      <h2>Payout Summary</h2>
      <table>
        <thead>
        <tr>
          <th>Payout Date</th>
          <th>Includes Dates</th>
          <th>Total Sales</th>
          <th>Charges (Inc VAT)</th>
          <th>Settlement Balance</th>
          <th>Settlement Hold</th>
          <th>Total Paid</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let payout of section.data">
          <td>{{ displayShortDate(payout.processedDate) }}</td>
          <td>{{ displayShortDate(payout.earliestTransactionDate) }}
            - {{ displayShortDate(payout.latestTransactionDate) }}
          </td>
          <td>{{ payout.totalSales | currency: 'R ' }}</td>
          <td>{{ payout.chargesVatIncl | currency: 'R ' }}</td>
          <td>{{ payout.tenantSettlement | currency: 'R ' }}</td>
          <td>{{ payout.settlementHold | currency: 'R ' }}</td>
          <td>{{ payout.totalPaid | currency: 'R ' }}</td>
        </tr>
        </tbody>
        <tfoot>
        <tr *ngIf="shouldShowPayoutTotals(i)">
          <td>Total</td>
          <td></td>
          <td>{{ summary.payoutTotals.totalSales | currency: 'R ' }}</td>
          <td>{{ summary.payoutTotals.chargesVatIncl | currency: 'R ' }}</td>
          <td>{{ summary.payoutTotals.tenantSettlement | currency: 'R ' }}</td>
          <td>{{ summary.payoutTotals.settlementHold | currency: 'R ' }}</td>
          <td>{{ summary.payoutTotals.totalPaid | currency: 'R ' }}</td>
        </tr>
        </tfoot>
      </table>
        <div *ngIf="shouldShowPayoutTotals(i)" class="notes-container">
        <div>Notes</div>
        <div><strong>Tenant settlement</strong> is the net amount payable of platform payments after charges, VAT on
          charges and settlement hold amounts are deducted
        </div>
        <div><strong>Settlement hold</strong> is additional amount paid to the landlord based on landlord/tenant payment
          arrangements
        </div>
        <div><strong>Total settled</strong> is the sum of the settlement hold and tenant settlement amounts</div>
      </div>
    </ng-container>

      <!-- Grand Totals -->
      <ng-container *ngIf="section.type == 'grandTotal'">
        <div
          style="border-top: 1px solid #000; padding-top: 10px; margin-top: 20px; display: flex; justify-content: right">
          <table style="width: 50%; font-family: Arial, sans-serif; border-collapse: collapse; margin-top: 20px;">
          <tr>
            <td style="padding: 8px; font-weight: bold;">Total sales</td>
            <td style="padding: 8px; text-align: right;">{{ summary.grandTotals.totalSales | currency: 'R ' }}</td>
          </tr>
          <tr>
            <td style="padding: 8px; font-weight: bold;">Total charges (incl VAT)</td>
            <td style="padding: 8px; text-align: right;">{{ summary.grandTotals.totalChargesIncl | currency: 'R ' }}
            </td>
          </tr>
            <tr>
              <td style="padding: 8px; font-weight: bold;">Settlement Holds</td>
              <td
                style="padding: 8px; text-align: right;">{{ summary.grandTotals.totalSettlementHolds | currency: 'R ' }}
              </td>
            </tr>
          <tr>
            <td style="padding: 8px; font-weight: bold;">Total external payments</td>
            <td
              style="padding: 8px; text-align: right;"> {{ makeNegative(summary.grandTotals.totalExternalPayments) | currency: 'R ' }}
            </td>
          </tr>
          <tr>
            <td style="padding: 8px; font-weight: bold;">Total settled</td>
            <td style="padding: 8px; text-align: right;"> {{ makeNegative(summary.grandTotals.totalSettled) | currency: 'R ' }}</td>
          </tr>
          <tr style="border-top: 1px solid #000;">
            <td style="padding: 8px; font-weight: bold;">Settlement balance for the period</td>
            <td
              style="padding: 8px; text-align: right;">{{ summary.grandTotals.settlementBalanceForPeriod | currency: 'R ' }}
            </td>
          </tr>
        </table>
      </div>
    </ng-container>
    </div>

  </div>
</div>
